// Theme barrel export for easy importing
export { colors, typography, getStatusColor, getChipColors, getDecorativeChipColors } from './colors';
export { theme, themeExtensions } from './theme';
